import React from "react";
import ReportTableScroll from "./ReportTableScroll";

export default function GiftCardsByHousehold({ rows, year, error, exportControl }) {
  return (
    <section className="fb-card p-4 sm:p-6" data-testid="gift-cards-by-household"
      aria-labelledby="gift-cards-by-household-title">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <h3 id="gift-cards-by-household-title" className="text-xl font-semibold"
          style={{ fontFamily: "Outfit" }}>Gift Cards by Household</h3>
        {!error && rows?.length > 0 && (
          <div className="w-full sm:w-auto">{exportControl}</div>
        )}
      </div>
      <p className="text-sm mb-4" style={{ color: "var(--fb-text-muted)" }}>
        Gift cards to include in each household’s bag for {year}. One card per recipient aged 10–18.
      </p>
      {error ? (
        <p role="alert" className="text-sm text-red-700">Could not load household gift card counts. {error}</p>
      ) : rows === undefined ? (
        <p role="status" className="text-sm">Loading household gift card counts…</p>
      ) : rows.length === 0 ? (
        <p className="py-8 text-center text-sm" style={{ color: "var(--fb-text-muted)" }}>
          No enrolled households for {year}.
        </p>
      ) : (
        <ReportTableScroll label="Gift Cards by Household table">
          <table className="w-full text-sm">
            <thead><tr style={{ background: "var(--fb-bg)" }}>
              <th scope="col" className="text-left px-4 py-3 font-semibold uppercase tracking-wider text-xs">Household ID</th>
              <th scope="col" className="text-right px-4 py-3 font-semibold uppercase tracking-wider text-xs">Gift Cards Needed</th>
            </tr></thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={`${row.household_id}-${index}`} className="border-t" style={{ borderColor: "var(--fb-border)" }}>
                  <td className="px-4 py-3 font-mono text-xs" style={{ overflowWrap: "anywhere" }}>{row.household_id || "—"}</td>
                  <td className="px-4 py-3 text-right tabular-nums font-bold">{row.gift_card_count}</td>
                </tr>
              ))}
            </tbody>
            <tfoot><tr className="border-t" style={{ borderColor: "var(--fb-border)" }}>
              <th scope="row" className="px-4 py-3 text-left">Total gift cards</th>
              <td className="px-4 py-3 text-right tabular-nums font-bold">
                {rows.reduce((total, row) => total + row.gift_card_count, 0)}
              </td>
            </tr></tfoot>
          </table>
        </ReportTableScroll>
      )}
    </section>
  );
}
